import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import { useLayoutMenuList } from 'modules/layout/hooks/useLayoutMenuList';
import { ReactComponent as LogoutIcon } from '../../../../../src/assets/icons/Navegation/cerrar-sesion.svg';
import { ReactComponent as HomeIcon } from '../../../../../src/assets/icons/Navegation/inicio.svg';
import { ReactComponent as MarketingIcon } from '../../../../../src/assets/icons/Navegation/kpis.svg';
import MenuCheckImeiWidget from '../widgets/MenuCheckImeiWidget';
import MenuCheckZipcodeWidget from '../widgets/MenuCheckZipcodeWidget';
import { icons } from './Styles/StylesIcons';
import CustomListItem from './components/CustomListItem';
import MarketingMenu from './components/MarketingMenu';
import { menusConfig } from './data/menusConfig';

const LayoutMenuList = (props) => {
  const menuState = useLayoutMenuList() || {};

  const {
    activeStyle,
    open,
    userPermissions,
    handlePopoverOpen,
    handlePopoverClose,
    header,
    isPopoverOpen,
    popoverAnchorEl,
    handleClickMarketing,
    openMenuMarketing,
  } = menuState;

  return (
    <Grid className={'layout-menu-list'}>
      <List>
        <MenuCheckImeiWidget parentProps={props} userPermissions={userPermissions} />
        <Divider style={{ margin: '0 0 4px 0' }} />
        <MenuCheckZipcodeWidget parentProps={props} userPermissions={userPermissions} />
        <Divider style={{ margin: '0 0 4px 0' }} />

        <CustomListItem
          text='Inicio'
          to='/dashboard'
          title='Inicio'
          activeStyle={activeStyle}
          open={open}
          icon={<HomeIcon style={icons} />}
        />

        {menusConfig.map(({ ListItemComponent, key, openProp, handleClickProp, extraProps }) => {
          if (key === 'marketing') {
            return (
              <MarketingMenu
                key={key}
                userPermissions={userPermissions}
                handleClick={handleClickMarketing}
                IconComponent={(props) => <MarketingIcon style={icons} {...props} />}
                openMenu={openMenuMarketing}
                activeStyle={activeStyle}
                drawerOpen={open}
                header={header}
                handlePopoverOpen={handlePopoverOpen('marketing')}
                handlePopoverClose={handlePopoverClose}
                openPopover={isPopoverOpen('marketing')}
                anchorEl={popoverAnchorEl}
              />
            );
          }
          return (
            <ListItemComponent
              key={key}
              userPermissions={userPermissions}
              {...{ [openProp]: menuState[openProp] }}
              {...{
                [handleClickProp]: menuState[handleClickProp],
              }}
              activeStyle={activeStyle}
              drawerOpen={open}
              header={header}
              handlePopoverOpen={handlePopoverOpen(key)}
              handlePopoverClose={handlePopoverClose}
              openPopover={isPopoverOpen(key)}
              anchorEl={popoverAnchorEl}
              {...extraProps}
            />
          );
        })}
      </List>
      <Divider />
      <List>
        <CustomListItem
          text='Salir'
          to='/close'
          title='Cerrar sesión'
          activeStyle={activeStyle}
          open={open}
          icon={<LogoutIcon style={icons} />}
        />
      </List>
    </Grid>
  );
};

export default LayoutMenuList;
